import React from "react"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import * as filingsTableActionCreators from "app/static/frontend/pac/action-creators/filings-table-action-creators"
import { Button } from "quorumdesign"
import { pacActionConnection } from "sheets/components/cells/action-buttons/selectors"

export const UnconnectedArchivePacFileAction = ({ fields, type, icon, text, id, archivePacFileFromListView }) => {
    const disabled = fields.isFiled || !fields.isArchivable

    return (
        <Button
            type={type}
            leftIcon={icon}
            text={text}
            disabled={disabled}
            title={disabled ? "Cannot archive a filing that is already filed, or is not the most recent." : undefined}
            onClick={() => archivePacFileFromListView(id)}
        />
    )
}

UnconnectedArchivePacFileAction.propTypes = {
    type: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    fields: PropTypes.object.isRequired,
    archivePacFileFromListView: PropTypes.func.isRequired,
}

export default connect(pacActionConnection, {
    archivePacFileFromListView: filingsTableActionCreators.archivePacFileFromListView,
})(UnconnectedArchivePacFileAction)
